import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex({ jc: "center", ai: "center" })}
  gap: 0.5rem;
  align-self: stretch;
`;

export const StyledRectangleContainer = styled(Box)`
  ${flex({ fd: "column", ai: "flex-start" })};
  gap: 2px;
  padding: 2px 3px;
  width: 33px;
  height: 20px;
  flex: 1 0 0;
  border-radius: 2px;
  background-color: #95cde7;
`;

export const StyledRectangleChildContainer = styled(Box, {
  shouldForwardProp: (propName) => !["bgColor"].includes(propName),
})<{
  bgColor: string;
}>`
  border-radius: 2px;
  background-color: ${({ bgColor }) => bgColor};
`;
